import { createTheme, type PaletteMode, alpha } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  const isLight = mode === "light";

  return createTheme({
    palette: {
      mode,
      primary: isLight
        ? { main: "#1a1a2e", light: "#3a3a5e", dark: "#0d0d17" }
        : { main: "#e8e8e8", light: "#ffffff", dark: "#b0b0b0" },
      secondary: { main: isLight ? "#e63946" : "#ff6b6b" },
      background: isLight
        ? { default: "#fafafa", paper: "#ffffff" }
        : { default: "#121212", paper: "#1e1e1e" },
    },
    typography: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      h1: { fontFamily: '"Playfair Display", serif', fontWeight: 700 },
      h2: { fontFamily: '"Playfair Display", serif', fontWeight: 700 },
      h3: { fontFamily: '"Playfair Display", serif', fontWeight: 600 },
      h4: { fontFamily: '"Playfair Display", serif', fontWeight: 600 },
      h5: { fontFamily: '"Playfair Display", serif', fontWeight: 500 },
      h6: { fontFamily: '"Playfair Display", serif', fontWeight: 500 },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 600,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontWeight: 600,
            fontSize: "0.7rem",
            letterSpacing: "0.05em",
            textTransform: "uppercase",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: ({ theme }) => ({
            transition: "box-shadow 0.2s ease",
            "&:hover": {
              boxShadow: theme.shadows[4],
            },
          }),
        },
      },
    },
  });
}
